import React, { useState, useEffect } from 'react';

import ObjectiveForm from '@components/lpc/Pot/AmountModule/Objective/ObjectiveForm/ObjectiveForm';
import { potType } from '@propTypes/potTypes';

type ObjectiveProps = {
    personRole: string;
    potRef: string;
    handleDateChange: (name: string, val: string) => void;
    handleAmountChange: (val: number) => void;
    pot: potType;
};

const Objective = ({ potRef, personRole, pot, handleDateChange, handleAmountChange }: ObjectiveProps) => {
    const [isEditing, setIsEditing] = useState<boolean>(false);

    const [isObjectiveCompleted, setIsObjectiveCompleted] = useState<boolean>(false);

    const onToggleForm = (value: boolean) => {
        setIsEditing(value);
    };

    const onSetEditing = (value: boolean) => {
        setIsEditing(value);
    };

    useEffect(() => {
        if (pot.poolObjective?.amountToReach) {
            setIsObjectiveCompleted(pot.collectedAmount >= pot.poolObjective.amountToReach);
        }
    }, [pot.collectedAmount]);

    return (
        <>
            <ObjectiveForm
                isOffered={pot.isOffered}
                potRef={potRef}
                personRole={personRole}
                handleDateChange={(name, value) => handleDateChange(name, value)}
                handleAmountChange={(value) => handleAmountChange(value)}
                pot={pot}
                isEditing={isEditing}
                onToggleForm={(value: boolean) => onToggleForm(value)}
                onSetEditing={(value: boolean) => onSetEditing(value)}
                isObjectiveCompleted={isObjectiveCompleted}
            />
        </>
    );
};
export default Objective;
